export default __webpack_public_path__ + "static/media/atm.inline.ca339262.svg";